<template>
  <div v-if="!loading" class="sp-mode">
    <sp-site-header/>
    <article>
      <div id="updateDate">
        <div class="container">
          <h1 class="update_time" v-if="todayDelays.created_at">{{ todayDelays.created_at | jpfulltime }}更新</h1>
        </div>
      </div>
      <div class="contents container">
        <ul>
          <li v-bind:key="area.area_id" v-for="area in areas">
            <router-link :to="{ name: 'SpLineList', params: { areaId: area.area_id } }">
              <div class="area_name">
                {{ area.display_name }}エリア
              </div>
              <div class="arrow">
                <font-awesome-icon v-bind:class="{ delayexist: delayExists(area.area_id) === true }" :icon="['fas', 'chevron-right']"></font-awesome-icon>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="comment container">
        ※ エリア名をタップすると、対象エリアの遅延証明書の掲載状況を路線別に表示します。
      </div>
    </article>
    <sp-site-footer/>
  </div>
</template>

<script>
import SpSiteHeader from '@/components/sp/SpSiteHeader'
import SpSiteFooter from '@/components/sp/SpSiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'SpSiteTop',
  components: {
    SpSiteHeader,
    SpSiteFooter
  },
  created () {
    this.$store.dispatch('areaLine/all')
    this.$store.dispatch('timeZone/all')
    const unwatchAreaLine = this.$store.watch(
      (state) => state.areaLine.status,
      (value) => {
        if (value === 'init') {
          unwatchAreaLine()
          this.init(true)
        }
      }
    )
    const unwatchTimeZone = this.$store.watch(
      (state) => state.timeZone.status,
      (value) => {
        if (value === 'init') {
          unwatchTimeZone()
          this.init(true)
        }
      }
    )
  },
  watch: {
    $route (to, from) {
      this.init()
    },
    loadedAt (oldVal, newVal) {
      this.init()
    }
  },
  methods: {
    delayExists (areaId) {
      if (this.todayDelayStatus === 'init') {
        return this.todayDelays.areas.find((area) => area.area_id === areaId).have_delay_certificate
      }
    },
    init (checkMaster) {
      if (checkMaster && (this.areaStatus !== 'init' || this.timeZoneStatus !== 'init')) {
        return
      }
      this.$store.dispatch('areaLine/setAreaId', 0)
      this.$store.commit('delaycertificatetoday/setStatus', '')
      this.$store.dispatch('delaycertificatetoday/all', [this.areas, this.timeZones])
      this.checkLoaded()
    },
    checkLoaded () {
      const timer = setInterval(() => {
        if (this.todayDelayStatus === 'init') {
          clearInterval(timer)
          this.$store.commit('loading/setStatus', false)
        }
      }, 100)
    },
    reload () {
      this.checkLoaded()
    }
  },
  computed: {
    ...mapState('delaycertificatetoday', {
      todayDelays: state => state.todayDelays,
      todayDelayStatus: state => state.status
    }),
    ...mapState('areaLine', {
      areas: state => state.areas,
      areaStatus: state => state.status,
      loadedAt: state => state.loadedAt
    }),
    ...mapState('timeZone', {
      timeZones: state => state.timeZones,
      timeZoneStatus: state => state.status,
      activeTimeZone: state => state.activeTimeZone
    }),
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
.update_time {
  font-size: 18px;
}
#site_info {
  background: white;
  border: solid 1px #e6e6e6;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
#updateDate {
  border-bottom: solid 2px #3070B3;
  h1 {
    font-weight: 600;
    font-size: 1.0rem;
    line-height: 3.0rem;
    padding: 0;
    margin: 0;
  }
}
.contents {
  ul {
    list-style: none;
    padding-left: 0;
    li {
      line-height: 3.0rem;
      border-bottom: solid 1px #E6E6E6;
      height: 3.0rem;
      a {
        .area_name {
          position: absolute;
          padding-left: 0.3rem;
          color: #1a1a1a;
          font-size: 1rem;
          font-weight: 600;
          left: 1rem;
          right: 1rem;
          height: 3rem;
        }
        .arrow {
          float: right;
          width: 1rem;
          font-size: 1.0rem !important;
          position: absolute;
          right: 0.9rem;
          svg {
            color: #ccc;
            margin-right: 0.5rem;
            &.delayexist {
              color: $primary;
            }
          }
        }
      }
      svg {
        margin-right: 0.5rem;
      }
    }
  }
}
.comment {
  line-height: 1.5rem;
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sp/SpSiteTop.vue